// Frame Tool — creates rectangular/elliptical frame placeholders for image placement.

import { screenToDoc } from "../render/Viewport";
import type { PointerSample, Tool, ToolContext } from "./Tool";

export type FrameShape = "rect" | "ellipse";

export class FrameTool implements Tool {
  readonly id = "frame";
  readonly shortcut = "K";

  shape: FrameShape = "rect";
  private start: { x: number; y: number } | null = null;
  frames: Array<{ id: string; x: number; y: number; w: number; h: number; shape: FrameShape }> = [];

  onPointerDown(ctx: ToolContext, s: PointerSample): void {
    if (!ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);
    this.start = { x: p.x, y: p.y };
  }

  onPointerUp(ctx: ToolContext, s: PointerSample): void {
    if (!this.start || !ctx.doc) return;
    const p = screenToDoc(ctx.viewport, s.x, s.y);

    let x = Math.min(this.start.x, p.x);
    let y = Math.min(this.start.y, p.y);
    let w = Math.abs(p.x - this.start.x);
    let h = Math.abs(p.y - this.start.y);

    if (s.shiftKey) {
      const m = Math.max(w, h);
      w = m;
      h = m;
    }

    if (w > 2 && h > 2) {
      this.frames.push({
        id: crypto.randomUUID(),
        x: Math.round(x),
        y: Math.round(y),
        w: Math.round(w),
        h: Math.round(h),
        shape: this.shape,
      });
    }

    this.start = null;
    ctx.requestRender();
  }
}
